import { IconHeartFilled, IconTime } from '@holbonkit/icons'
import { Alert, Box, Button, Text, Title } from '@holbonkit/ui'
import { useLocation, useNavigate } from '@tanstack/react-router'
import clsx from 'clsx'

import { setLocalStorageValue } from '@/shared/hooks/use-local-storage'
import { currencyParser } from '@/shared/lib/currency-parser'
import { IconX } from '@/shared/ui/icon/icon-x'

import styles from './withdrawal-smz-result.module.scss'

export const WithdrawalSMZResult = () => {
    const location = useLocation()
    const navigate = useNavigate()
    const amount = location.search.amount
    const status = location.search.status

    const handleDone = (from?: string) => {
        navigate({ to: '/withdrawal-smz', search: { from } })
    }

    const handleChangeSbp = () => {
        navigate({
            to: '/withdrawal-smz/account-link',
            search: {
                wrong_sbp: true,
            },
        })
    }

    if (status === 'in_progress') {
        return (
            <Box className={styles['result-page']}>
                <Box
                    className={clsx(
                        styles['result-page__icon'],
                        styles['result-page__icon--in-progress'],
                    )}
                >
                    <IconTime color='var(--text-and-icon-secondary)' size={32} />
                </Box>
                <Title variant='header-20-medium'>Операция в обработке</Title>
                <Box className={styles['result-page__amount']}>
                    <Title variant='extra-48-bold'>{currencyParser(amount)}</Title>
                    <Title
                        className={styles['result-page__amount--currency']}
                        variant='extra-48-bold'
                    >
                        ₽
                    </Title>
                </Box>
                <Text className={styles['result-page__text']} variant='body-m-16-regular'>
                    Ждём подтверждения банка, это займёт
                    <br />
                    пару минут. Смотрите статус в последних
                    <br />
                    операциях
                </Text>

                <Alert
                    className={styles['result-page__alert']}
                    icon={<IconHeartFilled color='var(--background-brand)' size={24} />}
                    size='md'
                    variant='default'
                >
                    Комиссию за вывод Drivee взял
                    <br />
                    на себя
                </Alert>
                <Button
                    className={styles['result-page__button']}
                    size='lg'
                    variant='primary'
                    onClick={() => {
                        setLocalStorageValue('withdrawal-smz-onboarding', 'showed')
                        handleDone()
                    }}
                >
                    Готово
                </Button>
            </Box>
        )
    }

    if (status === 'error_sbp') {
        return (
            <Box className={styles['result-page']}>
                <Box
                    className={clsx(
                        styles['result-page__icon'],
                        styles['result-page__icon--error'],
                    )}
                >
                    <IconX color='var(--extensions-text-and-icon-error)' size={32} />
                </Box>
                <Title variant='header-20-medium'>Вывод средств отклонён</Title>
                <Box className={styles['result-page__amount']}>
                    <Title variant='extra-48-bold'>{currencyParser(amount)}</Title>
                    <Title
                        className={styles['result-page__amount--currency']}
                        variant='extra-48-bold'
                    >
                        ₽
                    </Title>
                </Box>
                <Text className={styles['result-page__text']} variant='body-m-16-regular'>
                    Вывод на счёт другого человека
                    <br />
                    невозможен. Укажите номер,
                    <br />
                    привязанный к вашему личному счёту СБП
                </Text>

                <Button
                    className={styles['result-page__button']}
                    size='lg'
                    variant='primary'
                    onClick={handleChangeSbp}
                >
                    Изменить номер
                </Button>
            </Box>
        )
    }

    return (
        <Box className={styles['result-page']}>
            <Box className={clsx(styles['result-page__icon'], styles['result-page__icon--error'])}>
                <IconX color='var(--extensions-text-and-icon-error)' size={32} />
            </Box>
            <Title variant='header-20-medium'>Вывод средств отклонён</Title>
            <Box className={styles['result-page__amount']}>
                <Title variant='extra-48-bold'>{currencyParser(amount)}</Title>
                <Title className={styles['result-page__amount--currency']} variant='extra-48-bold'>
                    ₽
                </Title>
            </Box>
            <Text className={styles['result-page__text']} variant='body-m-16-regular'>
                Текст ошибки от провайдера
            </Text>

            <Button
                className={styles['result-page__button']}
                size='lg'
                variant='primary'
                onClick={() => {
                    handleDone('result')
                }}
            >
                Понятно
            </Button>
        </Box>
    )
}
